import styled from 'styled-components'

const StErrorLayout = styled.div`
  display: flex;
  flex-flow: column;
  flex: 1;
  height: 100%;

  ${({ theme }) => `
    padding: ${theme.UI.SpacingPx.Space6};
    padding-bottom: calc(${theme.UI.Spacing.Space6 * 2}px + max(var(--safe-area-inset-bottom), 20px));
    padding-top: calc(${theme.UI.Spacing.Space6}px + max(var(--safe-area-inset-top), 20px));
  `}
`

export { StErrorLayout }
